import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './features/auth/services/auth.service';
import { TokenService } from './features/auth/services/token.service';
import { UserGroup } from './constants/Enums';

@Component({
  selector: 'app-root-redirect',
  template: '',
  standalone: true,
})
export class RootComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private tokenService = inject(TokenService);

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.tokenService.initializeAutoRefresh();
      // Get user from localStorage to check group
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.group === UserGroup.ADMIN_GROUP) {
        this.router.navigate(['/inicio']);
      } else {
        this.router.navigate(['/campaña']);
      }
    } else {
      this.router.navigate(['/iniciar']);
    }
  }
}
